import i18next from 'i18next';
import { Nullable } from '@mobalytics/shared';
import { PlanExtraFeature, PlanFrameOption } from '../../../__generated/treasury/types';

export const processBestChoice = (
  frame: Nullable<PlanFrameOption | null>,
  extraFeatures: Nullable<(PlanExtraFeature | null)[]>,
  frameText: Nullable<string>,
  t: i18next.TFunction
): string | null => {
  if (extraFeatures?.includes(PlanExtraFeature.EGG_SKIN)) {
    return t('Limited Time: Free Legend', { nsSeparator: '#' });
  }
  if (extraFeatures?.includes(PlanExtraFeature.SKIN_CODE)) {
    return t('Limited Time: Free Skin', { nsSeparator: '#' });
  }
  if (frame === PlanFrameOption.CURRENT_SEASON && frameText) {
    return frameText;
  }
  if (frame === PlanFrameOption.BEST_CHOICE) {
    return t('best choice');
  }
  return null;
};
